module.exports = __webpack_public_path__ + "media/images/ic-sacola-c143fe26690d29c08206049801bcc6a0.svg";